import { Component, OnInit, inject } from '@angular/core';
import { Validators, FormControl, ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Blog } from 'src/app/common/Blog';
import { BlogService } from 'src/app/services/blog.service';
import { CommonModule, Location } from '@angular/common';
import { endOfDay } from 'date-fns';
import { CallApiService } from '../../services/api-action.service';
import { AsyncClickDirective } from '../../directives/async-click.directive';
import { EMPTY, Observable, tap } from 'rxjs';
import { FormRowComponent } from '../form-row/form-row.component';

/** The blog post form; its type is inferred from here (#199). */
function buildBlogForm(fb: FormBuilder, blog: Blog) {
  return fb.group({
    body: [blog.body, [Validators.required, Validators.maxLength(500)]],
    validFrom: new FormControl(blog.validFrom ? new Date(blog.validFrom) : null),
    validTo: new FormControl(blog.validTo ? new Date(blog.validTo) : null),
    isActive: new FormControl(blog.isActive),
  });
}
type BlogForm = ReturnType<typeof buildBlogForm>;

@Component({
    imports: [CommonModule, ReactiveFormsModule, AsyncClickDirective, FormRowComponent],
    selector: 'app-blog-edit',
    templateUrl: './blog-edit.component.html',
    styleUrls: ['./blog-edit.component.css']
})
export class BlogEditComponent implements OnInit {
  fb = inject(FormBuilder);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private location = inject(Location);
  private blogService = inject(BlogService);
  private apiActionService = inject(CallApiService);

  constructor() {
    this.blog = new Blog();
    this.blogForm = this.createForm(this.blog);
  }

  public blog: Blog;
  public blogForm: BlogForm;
  public submitted = false;
  public id: string;

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');

    if (this.id) {
      this.blogService.getById(this.id).subscribe((res: Blog) => {
        this.blog = res;
        this.blogForm = this.createForm(this.blog);
      });
    }
  }

  createForm(blog: Blog): BlogForm {
    return buildBlogForm(this.fb, blog);
  }

  submitForm(): Observable<unknown> {
    if (!this.blogForm.valid) {
      return EMPTY;
    }
    this.blog.body = this.blogForm.controls.body.value;
    this.blog.validFrom = this.blogForm.controls.validFrom.value;
    this.blog.validTo = this.blogForm.controls.validTo.value;
    this.blog.isActive = this.blogForm.controls.isActive.value;
    this.blog.validTo = endOfDay(this.blog.validTo);
    this.submitted = true;

    const isUpdate = !!this.blog.id;
    return this.apiActionService
      .callWithToasts$(
        isUpdate ? this.blogService.update(this.blog.id, this.blog) : this.blogService.create(this.blog),
        isUpdate ? $localize`Meldung wurde aktualisiert.` : $localize`Blog wurde angelegt.`,
        isUpdate
          ? $localize`Beim Aktualisieren der Meldung ist ein Fehler aufgetreten.`
          : $localize`Beim Anlegen der Meldung ist ein Fehler aufgetreten.`
      )
      .pipe(tap(() => this.router.navigateByUrl('shop-blog-list')));
  }

  onBackClicked() {
    this.location.back();
  }
}
